import { Link } from "react-router-dom";
import styles from "./Footer.module.css";

const WHATSAPP_NUMBER = "972505864422";
const waUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("היי לילך, הגעתי מהאתר שלך ואשמח שנדבר")}`;

const navLinks = [
  { label: "קצת עלי", href: "#about" },
  { label: "שירותי הסטודיו", href: "#services" },
  { label: "תהליך עבודה", href: "#process" },
  { label: "שאלות תשובות", href: "#faq" },
];

function Footer() {
  const handleClick = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className={styles.footer}>
      {/* Decorative watermark */}
      <div className={styles.watermark}>LILACH</div>

      <div className={styles.glass}>
        {/* Top accent line */}
        <div className={styles.accentLine} />

        {/* Main content */}
        <div className={styles.content}>
          {/* Brand center */}
          <div className={styles.brand}>
            <span className={styles.logo}>LILACH MORAD</span>
            <span className={styles.logoSub}>מתכננת ומעצבת פנים</span>
          </div>

          {/* Nav + Socials row */}
          <div className={styles.row}>
            <nav className={styles.nav}>
              {navLinks.map((link, i) => (
                <a
                  key={i}
                  href={link.href}
                  className={styles.navLink}
                  onClick={(e) => handleClick(e, link.href)}
                >
                  <span className={styles.navDot} />
                  {link.label}
                </a>
              ))}
            </nav>

            <div className={styles.contactCol}>
              <span className={styles.contactLabel}>עקבו אחרי</span>
              <div className={styles.socials}>
                <a href="https://www.instagram.com/lilach_morad_interior_design/" target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="Instagram">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="2" width="20" height="20" rx="5" />
                    <circle cx="12" cy="12" r="5" />
                    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
                  </svg>
                </a>
                <a href="https://www.facebook.com/lilach.benmoha" target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="Facebook">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
                  </svg>
                </a>
                <a href={waUrl} target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="WhatsApp">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" />
                  </svg>
                </a>
                <a href="tel:+972505864422" className={styles.socialLink} aria-label="טלפון">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className={styles.bottomBar}>
          <span className={styles.copy}>
            &copy; {new Date().getFullYear()} Lilach Morad Studio
            <span className={styles.copySep}>|</span>
            <Link to="/privacy" className={styles.privacyLink}>תקנון ומדיניות פרטיות</Link>
          </span>
          <button
            className={styles.backTop}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            aria-label="חזרה למעלה"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 19V5M5 12l7-7 7 7" />
            </svg>
          </button>
        </div>

        <div className={styles.byMe}>נבנה על ידי <a href="https://danielrozenblat.co.il/" rel="noopener noreferrer" target="_blank" className={styles.byMeLink}>דניאל רוזנבלט</a></div>
      </div>
    </footer>
  );
}

export default Footer;
